<script setup lang="ts">
import { UiIcon } from "@shopexperts/shared";

const props = withDefaults(defineProps<{
  showDivider?: boolean;
  class?: string;
}>(), {
  showDivider: true,
  class: '',
});

const emit = defineEmits<{
  (e: 'click', event: MouseEvent): void;
}>();
</script>

<template>
  <div 
    class="border-l-1 border-se-gray-300 drag-handle absolute top-0 bottom-0 right-0 px-2.5 flex-shrink-0 cursor-grab active:cursor-grabbing flex items-center justify-center self-stretch gap-2.5 transition-colors"
    :class="props.class"
    @click="emit('click', $event)"
  >
    <UiIcon 
      name="drag-handle" 
      class="w-auto h-auto text-gray-400 drag-handle-icon"
      :class="props.class"
    />
  </div>
  <div class="ml-2.5"></div>
</template>

